/*************
 * subscribe
 * Form controller for Subscribe form.
 * Submits a standard submission to IBM Watson. The IBM Watson
 * needs to have its submit redirection handled within its admin.
 *
 * We store in local storage because of SilverPop AJAX limitations.
 * By caching the current URL the user submitted from, we can then
 * redirect from the thank you page accordingly.
 *
 */

// Requires magnific to run
require('magnific-popup');
// Google Tag Manager DataLayer Helper
require('custom/gtm-datalayer');

custom.subscribe = (() => {
    const $subscribeForm = $('.js-subscribe-form'); // Subscribe Form
    const hash = window.location.hash; // Get current window location hash
    const $successModal = $('#subscribe-form-success'); // Success modal

    /******************
     * FORM VALIDATION HANDLING
     */

    // Run parsley validations
    if($subscribeForm.length) {
        $subscribeForm
            .parsley() // Bind validation
            .on('form:error', () => false) // Capture the default submission
            .on('form:success', () => {
                window.localStorage.setItem('retURL',window.location.origin + window.location.pathname + '#subscribe-form'); // Store current URL in local storage
                window.localStorage.setItem('hasSubscribed',true); // Set boolean if user has subscribed
                custom.gtmDatalayer.gtmPushElem($subscribeForm); // GTM event push

                return true // Perfect, send away
            });
    }

    /******************
     * MODAL TRIGGER BINDINGS
     */

    // If success hash and success modal exist, auto open the success modal
    if(hash && hash === '#subscribe-form-success' && $successModal.length) {
        // $.magnificPopup.open({
        //     items: {
        //         src: $successModal
        //     },
        //     type: 'inline'
        // });
    }
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/subscribe-form.js